import React, { useState } from "react";
import "../CSS/Contactus.css";
import { Link } from "react-router-dom";

const Contactus = () => {

const [formData,setFormData] = useState({
name:"",
email:"",
phone:"",
message:""
});

const handleChange = (e)=>{
setFormData({
...formData,
[e.target.name]:e.target.value
});
};

const handleSubmit = (e)=>{
e.preventDefault();

const text = `
Contact Form Details

Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Message: ${formData.message}
`;

const url = `https://wa.me/916393244687?text=${encodeURIComponent(text)}`;

window.open(url,"_blank");
};

  return (
    <section className="contact-page">

      {/* PAGE HEADER */}

      <div className="page-banner">
        <h1>Contact Us</h1>

        <p>
          <Link to="/">Home</Link> &gt;
          <span>Contact Us</span>
        </p>
      </div>

      <div className="contact-wrapper">

        {/* TOP INFO */}

        <div className="contact-top">

          <div className="contact-text">
            <h2>Get <span>in Touch</span></h2>
            <p>
              Come and visit our quarters or simply send us an email anytime you want.
              We are open to all suggestions from our clients.
            </p>
          </div>

          <div className="contact-details">

            <div className="contact-box">
              <h3>Address</h3>
              <p>
                2nd Floor, Vishwakarma Bhavan, Saibaba Road, opp. Anand Mangal Complex, Khar, Jawahar Nagar, Khar East, Mumbai, Maharashtra 40005
              </p>
            </div>

            <div className="contact-box">
              <h3>Phone</h3>
              <p>+91 6393244687</p>
            </div>

          </div>

        </div>

        {/* MAP + FORM */}

        <div className="contact-main">

          {/* GOOGLE MAP */}

          <div className="contact-map">

            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3770.875312386762!2d72.844404!3d19.069218999999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c9774e068629%3A0x761acddeb4ecf97c!2sCourt%20marriage%20in%20mumbai%20%7C%20Pandey%20and%20Associates!5e0!3m2!1sen!2sin!4v1773295955336!5m2!1sen!2sin"
              title="Google Map"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              style={{ border: 0, width: "100%", height: "420px" }}
            ></iframe>

          </div>


          {/* CONTACT FORM */}

          <div className="contact-form">

            <h3>Required fields are marked *</h3>

            <form onSubmit={handleSubmit}>

            <input
              type="text"
              name="name"
              placeholder="Your Name *"
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Your Email *"
              onChange={handleChange}
              required
            />

            <input
              type="text"
              name="phone"
              placeholder="Your Phone Number *"
              onChange={handleChange}
              required
            />

            <textarea
              name="message"
              placeholder="Your Message *"
              onChange={handleChange}
              required
            ></textarea>

            <button className="contact-btn" type="submit">
              Submit Message
            </button>

            </form>

          </div>

        </div>

      </div>

    </section>
  );
};

export default Contactus;